import { inject, Injector } from '@angular/core';
import { HttpInterceptorFn } from '@angular/common/http';
import { Router } from '@angular/router';
import { catchError, switchMap, take } from 'rxjs';
import { throwError } from 'rxjs';
import { AuthService } from '../services/auth.service';

export const authInterceptor: HttpInterceptorFn = (req, next) => {
  const injector = inject(Injector);
  const router = inject(Router);
  const auth = injector.get(AuthService);

  return auth.getToken().pipe(
    take(1),
    switchMap(token => {
      if (!token) {
        return next(req);
      }

      const authReq = req.clone({
        setHeaders: {
          Authorization: `Bearer ${token}`
        }
      });

      return next(authReq).pipe(
        catchError(err => {
          if (err.status === 401) {
            auth.logout();
            router.navigate(['/login']);
          }
          return throwError(() => err);
        })
      );
    })
  );
};